var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Form, Grid, Header, Input, Select } from "semantic-ui-react";
import ErrorDisplay from "../../ErrorDisplay";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { adminConfigurations, DetectOnly, ExtrasOnly, Other, ProbeDetect, ProbeOnly, StarterKitProbe } from "../../KitDeserializer";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { buildOnComponentStateChangeHandler } from "../FormState";
import { discountMessage, priceColumn, PriceDisplay, ToggleableKitComponent } from "../rna-fish/EditKitForm";
import { ErrorElements } from "../rna-fish/NewRnaFishKitPage";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { AmplifierForm } from "./AmplifierForm";
import BufferForm from "./BufferForm";
import ChromogenForm from "./ChromogenForm";
import RnaCishAdminKitSerializer from "./KitSerializer";
import MiscellaneousComponentForm from "./MiscellaneousComponentForm";
import ProbeSetForm, { RnaCishEditableOrganism, RnaCishEditableTarget } from "./ProbeSetForm";
import { ProtocolTypeEnum } from "./ProKitForm";
import { Hapten } from "./RnaCatalog";
var AdminEditKitForm = /** @class */ (function (_super) {
    __extends(AdminEditKitForm, _super);
    function AdminEditKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onBufferStateChange = buildOnComponentStateChangeHandler(bufStateWrangler, _this.props.setFormState);
        _this.onChromogenStateChange = buildOnComponentStateChangeHandler(chromogenStateWrangler, _this.props.setFormState);
        _this.onMiscComponentStateChange = buildOnComponentStateChangeHandler(miscComponentStateWrangler, _this.props.setFormState);
        _this.onMiscComponentEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { miscComponentEnabled: !s.miscComponentEnabled };
            }, function (newState) {
                if (newState.miscComponentEnabled) {
                    _this.onMiscComponentStateChange({}, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onProbeSetEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { probeSetEnabled: !s.probeSetEnabled };
            }, function (newState) {
                if (newState.probeSetEnabled) {
                    _this.onProbeSetStateChange({}, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onProbeSetStateChange = function (updateObjOrFn, callback) {
            var stateCalculator;
            if (typeof updateObjOrFn === "function") {
                stateCalculator = function (oldState) {
                    // apply the provided function
                    return updateObjOrFn(oldState.probeSetState);
                };
            }
            else {
                stateCalculator = function () {
                    // just return the plain object
                    return updateObjOrFn;
                };
            }
            _this.props.setFormState(function (oldState) { return ({
                probeSetState: Object.assign({}, oldState.probeSetState, stateCalculator(oldState))
            }); }, function (newState) {
                // propagate to amplifier component
                if (newState.probeSetState.target.variantId != null) {
                    _this.onAmpStateChange({
                        hcrAmplifier: newState.probeSetState.hcrAmplifier
                    }, callback);
                }
                else if (newState.probeSetState.target.variantId == null) {
                    _this.onAmpStateChange({
                        hcrAmplifier: newState.probeSetState.hcrAmplifier
                    }, callback);
                }
                else if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onAmpStateChange = function (updateObjOrFn, callback) {
            var stateCalculator;
            if (typeof updateObjOrFn === "function") {
                stateCalculator = function (oldState) {
                    // apply the provided function
                    return updateObjOrFn(oldState.ampState);
                };
            }
            else {
                stateCalculator = function () {
                    // just return the plain object
                    return updateObjOrFn;
                };
            }
            _this.props.setFormState(function (oldState) { return ({
                ampState: Object.assign({}, oldState.ampState, stateCalculator(oldState))
            }); }, function (newState) {
                // propagate to chromogen component
                if (newState.ampState.antiHapten2Ap.label === 'NONE' && _this.props.formState.chromogenState.chromogen.enzymeCompatibility === 'AP' ||
                    newState.ampState.antiHapten2Hrp.label === 'NONE' && _this.props.formState.chromogenState.chromogen.enzymeCompatibility === 'HRP') {
                    _this.onChromogenStateChange({
                        chromogen: {
                            id: 'NONE',
                            label: 'NONE',
                            protocolCompatibility: [],
                            enzymeCompatibility: '',
                            bufferCompatibility: {
                                id: 'NONE',
                                label: 'NONE'
                            }
                        },
                        chromogenBuffer: {
                            id: 'NONE',
                            label: 'NONE'
                        },
                        chromogenScaleSlides: 0,
                        chromogenBufferScaleSlides: 0,
                        hematoxylinScaleSlides: 0
                    }, callback);
                }
                else if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onCommentChange = function (event) {
            var str = event.currentTarget.value;
            _this.props.setFormState(function () {
                return {
                    comment: str
                };
            });
        };
        _this.onProtocolChange = function (_, data) {
            var protocolType = _this.props.catalog.cishProtocols.find(function (p) { return p.id === data.value; });
            if (protocolType === undefined) {
                throw new RangeError("Could not find protocol");
            }
            // If the platform is not Discovery then switch the prefilled status to false
            var prefilled = _this.props.formState.ampState.prefilled;
            if ((protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) !== ProtocolTypeEnum.ROCHE) {
                prefilled = false;
            }
            // If the platform is Discovery and scale is 90 then set prefilled to true
            if ((protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === ProtocolTypeEnum.ROCHE && _this.props.formState.scale === 90) {
                prefilled = true;
            }
            if (!_this.props.formState.chromogenState.chromogen.protocolCompatibility.some(function (p) { return p.id === protocolType.id; })) {
                _this.onChromogenStateChange({
                    chromogen: {
                        id: 'NONE',
                        label: 'NONE',
                        protocolCompatibility: [],
                        enzymeCompatibility: '',
                        bufferCompatibility: {
                            id: 'NONE',
                            label: 'NONE'
                        }
                    },
                    chromogenBuffer: {
                        id: 'NONE',
                        label: 'NONE'
                    },
                    chromogenScaleSlides: 0,
                    chromogenBufferScaleSlides: 0,
                    hematoxylinScaleSlides: 0
                });
            }
            var selectedEnzyme = _this.props.catalog.cishAmplifier
                .enzymes
                .find(function (c) {
                var _a, _b;
                return c.protocolType.id === (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) &&
                    c.displayName.trim() === ((_b = (_a = _this.props.formState.ampState.enzyme) === null || _a === void 0 ? void 0 : _a.displayName) === null || _b === void 0 ? void 0 : _b.trim());
            });
            _this.onAmpStateChange({
                enzyme: selectedEnzyme,
                prefilled: prefilled
            });
            _this.props.setFormState(function () {
                return {
                    protocolType: protocolType
                };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onConfigurationChange = function (_, data) {
            var config = _this.props.kitConfigurations.find(function (c) { return c === data.value; });
            if (config === undefined) {
                throw new RangeError("Could not find configuration");
            }
            if (config === StarterKitProbe) {
                var scale = 10;
                _this.onProbeSetStateChange({
                    scale: scale,
                    customScale: scale,
                    probeHybridizationAScale: scale,
                    probeHybridizationBScale: scale,
                    customPrice: {
                        effectivePriceCents: 0,
                        listPriceCents: 0
                    },
                });
                _this.props.setFormState(function () {
                    return {
                        config: config,
                        scale: 10,
                        probeSetEnabled: true,
                        ampEnabled: false,
                        buffersEnabled: false,
                        chromogenEnabled: false,
                        reasonForOther: "",
                        reasonForOtherExplanation: ""
                    };
                }, _this.onUserSelection);
            }
            if (config === ProbeOnly) {
                var scale_1;
                if (_this.props.formState.probeSetState.scale === 0 || _this.props.formState.probeSetState.scale === 10) {
                    scale_1 = _this.props.catalog.probeSet.catalog.cishDefaultScale;
                }
                else {
                    scale_1 = _this.props.formState.probeSetState.scale;
                }
                _this.onProbeSetStateChange({
                    scale: scale_1,
                    customScale: scale_1,
                    probeHybridizationAScale: scale_1,
                    probeHybridizationBScale: scale_1,
                    customPrice: undefined
                });
                _this.onAmpStateChange({
                    prefilled: false
                });
                _this.props.setFormState(function () {
                    return {
                        config: config,
                        scale: scale_1,
                        probeSetEnabled: true,
                        ampEnabled: false,
                        buffersEnabled: false,
                        chromogenEnabled: false,
                        reasonForOther: "",
                        reasonForOtherExplanation: ""
                    };
                }, _this.onUserSelection);
            }
            var adminAmpCatalog = _this.props.catalog.cishAmplifier;
            var ampState = _this.props.formState.ampState;
            var hcrAmplifier = ampState.hcrAmplifier;
            var hapten = ampState.hapten;
            var antiHapten1 = ampState.antiHapten1;
            var tyramideHapten = ampState.tyramideHapten;
            var antiHapten2Ap = ampState.antiHapten2Ap;
            var antiHapten2Hrp = ampState.antiHapten2Hrp;
            var enzymeConfig = adminAmpCatalog.enzymes.find(function (e) {
                return e.protocolType.id === _this.props.formState.protocolType.id
                    && e.amplifier.id === hcrAmplifier.id
                    && e.hapten.id === hapten.id
                    && e.antiHapten1.id === antiHapten1.id
                    && e.tyramideHapten.id === tyramideHapten.id
                    && e.antiHapten2Ap.id === antiHapten2Ap.id
                    && e.antiHapten2Hrp.id === antiHapten2Hrp.id;
            });
            if (config === ProbeDetect) {
                var scale_2;
                if (_this.props.formState.ampState.amplifierScale === 0) {
                    scale_2 = adminAmpCatalog.proDefaultAmplifierScale;
                }
                else {
                    scale_2 = _this.props.formState.ampState.amplifierScale;
                }
                var chromogenScale_1;
                if (_this.props.formState.chromogenState.chromogenScaleSlides === 0) {
                    chromogenScale_1 = 0;
                }
                else {
                    chromogenScale_1 = scale_2;
                }
                _this.onProbeSetStateChange({
                    scale: scale_2,
                    probeHybridizationAScale: scale_2,
                    probeHybridizationBScale: scale_2,
                    customPrice: undefined
                }, function () {
                    _this.onAmpStateChange({
                        amplifierScale: scale_2,
                        antiHapten1Scale: scale_2,
                        tyramideHaptenScale: scale_2,
                        antiHapten2ApScale: enzymeConfig ?
                            (enzymeConfig.antiHapten2Ap.id !== "NONE" ? scale_2 : 0)
                            : (scale_2),
                        antiHapten2HrpScale: enzymeConfig ?
                            (enzymeConfig.antiHapten2Hrp.id !== "NONE" ? scale_2 : 0)
                            : (scale_2),
                        hcrAmplifier: enzymeConfig ? enzymeConfig.amplifier
                            : (hcrAmplifier.id !== "NONE" ? hcrAmplifier : _this.props.formState.probeSetState.hcrAmplifier),
                        hapten: enzymeConfig ? enzymeConfig.hapten : adminAmpCatalog.defaultHapten,
                        antiHapten1: enzymeConfig ? enzymeConfig.antiHapten1 : adminAmpCatalog.defaultAntiHapten1,
                        tyramideHapten: enzymeConfig ? enzymeConfig.tyramideHapten : adminAmpCatalog.defaultTyramideHapten,
                        antiHapten2Ap: enzymeConfig ? enzymeConfig.antiHapten2Ap : adminAmpCatalog.defaultAntiHapten2Ap,
                        antiHapten2Hrp: enzymeConfig ? enzymeConfig.antiHapten2Hrp : adminAmpCatalog.defaultAntiHapten2Hrp,
                        enzyme: enzymeConfig ? enzymeConfig : undefined,
                        customPrice: undefined
                    }, function () {
                        _this.onBufferStateChange({
                            antigenRetrievalScale: scale_2,
                            amplificationBufferScale: scale_2,
                            hrpQuencherScale: scale_2,
                            preHybridizationScale: 0,
                            blockingSolutionScale: scale_2,
                            bluingAgentScale: scale_2,
                            dewaxScale: scale_2,
                            endogenousEnzymeScale: scale_2,
                            customPrice: undefined
                        }, function () {
                            _this.onChromogenStateChange({
                                chromogen: _this.props.formState.chromogenState.chromogen,
                                chromogenBuffer: _this.props.formState.chromogenState.chromogen.bufferCompatibility,
                                chromogenScaleSlides: chromogenScale_1,
                                chromogenBufferScaleSlides: chromogenScale_1,
                                hematoxylinScaleSlides: chromogenScale_1
                            });
                        });
                    });
                });
                _this.props.setFormState(function () {
                    return {
                        config: config,
                        scale: scale_2,
                        probeSetEnabled: true,
                        ampEnabled: true,
                        buffersEnabled: true,
                        chromogenEnabled: true,
                        reasonForOther: "",
                        reasonForOtherExplanation: ""
                    };
                }, _this.onUserSelection);
            }
            if (config === DetectOnly) {
                var scale_3;
                if (_this.props.formState.ampState.amplifierScale === 0) {
                    scale_3 = adminAmpCatalog.proDefaultAmplifierScale;
                }
                else {
                    scale_3 = _this.props.formState.ampState.amplifierScale;
                }
                var chromogenScale_2;
                if (_this.props.formState.chromogenState.chromogenScaleSlides === 0) {
                    chromogenScale_2 = 0;
                }
                else {
                    chromogenScale_2 = scale_3;
                }
                _this.onAmpStateChange({
                    amplifierScale: scale_3,
                    antiHapten1Scale: scale_3,
                    tyramideHaptenScale: scale_3,
                    antiHapten2ApScale: enzymeConfig ?
                        (enzymeConfig.antiHapten2Ap.id !== "NONE" ? scale_3 : 0)
                        : (scale_3),
                    antiHapten2HrpScale: enzymeConfig ?
                        (enzymeConfig.antiHapten2Hrp.id !== "NONE" ? scale_3 : 0)
                        : (scale_3),
                    hcrAmplifier: enzymeConfig ? enzymeConfig.amplifier
                        : (hcrAmplifier.id !== "NONE" ? hcrAmplifier : adminAmpCatalog.defaultHcrAmplifier),
                    hapten: enzymeConfig ? enzymeConfig.hapten : adminAmpCatalog.defaultHapten,
                    antiHapten1: enzymeConfig ? enzymeConfig.antiHapten1 : adminAmpCatalog.defaultAntiHapten1,
                    tyramideHapten: enzymeConfig ? enzymeConfig.tyramideHapten : adminAmpCatalog.defaultTyramideHapten,
                    antiHapten2Ap: enzymeConfig ? enzymeConfig.antiHapten2Ap : adminAmpCatalog.defaultAntiHapten2Ap,
                    antiHapten2Hrp: enzymeConfig ? enzymeConfig.antiHapten2Hrp : adminAmpCatalog.defaultAntiHapten2Hrp,
                    enzyme: enzymeConfig ? enzymeConfig : undefined,
                    customPrice: undefined
                }, function () {
                    _this.onBufferStateChange({
                        antigenRetrievalScale: scale_3,
                        amplificationBufferScale: scale_3,
                        hrpQuencherScale: scale_3,
                        preHybridizationScale: 0,
                        blockingSolutionScale: scale_3,
                        bluingAgentScale: scale_3,
                        dewaxScale: scale_3,
                        endogenousEnzymeScale: scale_3,
                        customPrice: undefined
                    }, function () {
                        _this.onChromogenStateChange({
                            chromogen: _this.props.formState.chromogenState.chromogen,
                            chromogenBuffer: _this.props.formState.chromogenState.chromogen.bufferCompatibility,
                            chromogenScaleSlides: chromogenScale_2,
                            chromogenBufferScaleSlides: chromogenScale_2,
                            hematoxylinScaleSlides: chromogenScale_2
                        });
                    });
                });
                _this.props.setFormState(function () {
                    return {
                        config: config,
                        scale: scale_3,
                        probeSetEnabled: false,
                        ampEnabled: true,
                        buffersEnabled: true,
                        chromogenEnabled: true,
                        customPrice: undefined,
                        reasonForOther: ""
                    };
                }, _this.onUserSelection);
            }
            if (config === ExtrasOnly) {
                var scale_4 = _this.props.formState.chromogenState.chromogenScaleSlides !== 0 ?
                    _this.props.formState.chromogenState.chromogenScaleSlides : _this.props.catalog.cishChromogens.proDefaultChromogenScale;
                _this.onChromogenStateChange({
                    chromogen: _this.props.formState.chromogenState.chromogen,
                    chromogenBuffer: _this.props.formState.chromogenState.chromogen.bufferCompatibility,
                    chromogenScaleSlides: _this.props.formState.chromogenState.chromogenScaleSlides,
                    chromogenBufferScaleSlides: _this.props.formState.chromogenState.chromogenScaleSlides,
                    hematoxylinScaleSlides: _this.props.formState.chromogenState.chromogenScaleSlides
                });
                _this.props.setFormState(function () {
                    return {
                        config: config,
                        scale: scale_4,
                        probeSetEnabled: false,
                        ampEnabled: false,
                        buffersEnabled: false,
                        chromogenEnabled: true,
                        customPrice: undefined,
                        reasonForOther: "",
                        reasonForOtherExplanation: ""
                    };
                }, _this.onUserSelection);
            }
            if (config === Other) {
                _this.onProbeSetStateChange({
                    scale: 0,
                    probeHybridizationAScale: 0,
                    probeHybridizationBScale: 0,
                    customPrice: undefined
                }, function () {
                    _this.onAmpStateChange({
                        enzyme: undefined,
                        amplifierScale: 0,
                        antiHapten1Scale: 0,
                        tyramideHaptenScale: 0,
                        antiHapten2ApScale: 0,
                        antiHapten2HrpScale: 0,
                        hapten: new Hapten("NONE"),
                        antiHapten1: {
                            id: "NONE",
                            label: "NONE"
                        },
                        tyramideHapten: {
                            id: "NONE",
                            label: "NONE"
                        },
                        antiHapten2Ap: {
                            id: "NONE",
                            label: "NONE",
                            chromogenCompatibility: "NONE"
                        },
                        antiHapten2Hrp: {
                            id: "NONE",
                            label: "NONE",
                            chromogenCompatibility: "NONE"
                        },
                        customPrice: undefined
                    }, function () {
                        _this.onBufferStateChange({
                            antigenRetrievalScale: 0,
                            amplificationBufferScale: 0,
                            hrpQuencherScale: 0,
                            preHybridizationScale: 0,
                            blockingSolutionScale: 0,
                            bluingAgentScale: 0,
                            dewaxScale: 0,
                            endogenousEnzymeScale: 0,
                            customPrice: undefined
                        }, function () {
                            _this.onChromogenStateChange({
                                chromogen: {
                                    id: "NONE",
                                    label: "NONE",
                                    bufferCompatibility: {
                                        id: "NONE",
                                        label: "NONE"
                                    },
                                    enzymeCompatibility: "",
                                    protocolCompatibility: []
                                },
                                chromogenBuffer: {
                                    id: "NONE",
                                    label: "NONE"
                                },
                                chromogenScaleSlides: 0,
                                chromogenBufferScaleSlides: 0,
                                hematoxylinScaleSlides: 0
                            }, function () {
                                _this.onMiscComponentStateChange({
                                    description: "",
                                    scaleInMl: 0,
                                    scaleInSlides: 0
                                });
                            });
                        });
                    });
                });
                _this.props.setFormState(function () {
                    return {
                        config: config,
                        scale: 0,
                        probeSetEnabled: true,
                        ampEnabled: true,
                        buffersEnabled: true,
                        chromogenEnabled: true,
                        miscComponentEnabled: true
                    };
                }, _this.onUserSelection);
            }
        };
        _this.otherReasons = function () {
            return [
                {
                    text: "Troubleshooting",
                    value: "Troubleshooting"
                },
                {
                    text: "Beta Testing",
                    value: "Beta Testing"
                },
                {
                    text: "Product Partnership",
                    value: "Product Partnership"
                },
                {
                    text: "Sales Misc.",
                    value: "Sales Misc."
                }
            ];
        };
        _this.onReasonForOtherChange = function (_, data) {
            _this.props.setFormState(function () {
                return {
                    reasonForOther: data.value
                };
            }, _this.onUserSelection);
        };
        _this.onReasonForOtherExplanationChange = function (_, data) {
            _this.props.setFormState(function () {
                return {
                    reasonForOtherExplanation: data.value
                };
            }, _this.onUserSelection);
        };
        _this.onScaleChange = function (_, data) {
            var _a;
            var scale = _this.props.catalog.probeSet.catalog.cishScale.find(function (p) { return p === data.value; }) || data.value;
            var prefilled = _this.props.formState.ampState.prefilled;
            if (scale === 90 && ((_a = _this.props.formState.protocolType) === null || _a === void 0 ? void 0 : _a.id) === ProtocolTypeEnum.ROCHE) {
                prefilled = true;
            }
            var ah2ApScale;
            if (_this.props.formState.ampState.antiHapten2Ap != null && _this.props.formState.ampState.antiHapten2Ap.id !== "NONE") {
                ah2ApScale = scale;
            }
            var ah2HrpScale;
            if (_this.props.formState.ampState.antiHapten2Hrp != null && _this.props.formState.ampState.antiHapten2Hrp.id !== "NONE") {
                ah2HrpScale = scale;
            }
            var preHybridizationScale;
            if (_this.props.formState.config === Other) {
                preHybridizationScale = scale;
            }
            _this.props.setFormState(function () {
                return {
                    scale: scale
                };
            }, function () {
                _this.onAmpStateChange({
                    amplifierScale: scale,
                    antiHapten1Scale: scale,
                    tyramideHaptenScale: scale,
                    antiHapten2ApScale: ah2ApScale,
                    antiHapten2HrpScale: ah2HrpScale,
                    prefilled: prefilled
                }, function () {
                    _this.onBufferStateChange({
                        amplificationBufferScale: scale,
                        blockingSolutionScale: scale,
                        dewaxScale: scale,
                        antigenRetrievalScale: scale,
                        endogenousEnzymeScale: scale,
                        preHybridizationScale: preHybridizationScale,
                        hrpQuencherScale: scale,
                        bluingAgentScale: scale
                    }, function () {
                        _this.onProbeSetStateChange({
                            scale: scale,
                            customScale: scale,
                            probeHybridizationAScale: scale,
                            probeHybridizationBScale: scale
                        }, function () {
                            _this.onChromogenStateChange({
                                chromogenScaleSlides: _this.props.formState.config === ExtrasOnly && _this.props.formState.chromogenState.chromogen.id !== 'NONE' ? scale : (_this.props.formState.chromogenState.chromogenScaleSlides !== 0 ? scale : 0),
                                chromogenBufferScaleSlides: _this.props.formState.config === ExtrasOnly && _this.props.formState.chromogenState.chromogen.id !== 'NONE' ? scale : (_this.props.formState.chromogenState.chromogenBufferScaleSlides !== 0 ? scale : 0),
                                hematoxylinScaleSlides: _this.props.formState.config === ExtrasOnly && _this.props.formState.chromogenState.chromogen.id !== 'NONE' ? scale : (_this.props.formState.chromogenState.hematoxylinScaleSlides !== 0 ? scale : 0),
                            }, function () {
                                _this.onUserSelection();
                            });
                        });
                    });
                });
            });
        };
        _this.effectiveScales = function () {
            return uniqueBy(_this.props.catalog.cishAmplifier.proAmplifierScales.concat(_this.props.formState.scale), function (s) { return s; });
        };
        _this.onAmplifierEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { ampEnabled: !s.ampEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onChromogenEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { chromogenEnabled: !s.chromogenEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onBuffersEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { buffersEnabled: !s.buffersEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onUserSelection = function () {
            _this.loadPrice();
        };
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({
                priceLoading: true
            }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(AdminEditKitForm.serializeRnaCishKit(newState)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElements(json.errors); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElements) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: undefined
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    AdminEditKitForm.prototype.render = function () {
        var _a, _b, _c, _d;
        var amplifierComponent;
        var buffComponent;
        var psc;
        var chromogenComponent;
        if (this.props.formState.price) {
            if ((_a = this.props.formState.price.kit) === null || _a === void 0 ? void 0 : _a.amplifierComponent) {
                amplifierComponent = this.props.formState.price.kit.amplifierComponent;
            }
        }
        else {
            amplifierComponent = undefined;
        }
        if (this.props.formState.price) {
            if ((_b = this.props.formState.price.kit) === null || _b === void 0 ? void 0 : _b.buffersComponent) {
                buffComponent = this.props.formState.price.kit.buffersComponent;
            }
        }
        else {
            buffComponent = undefined;
        }
        if (this.props.formState.price) {
            if ((_c = this.props.formState.price.kit) === null || _c === void 0 ? void 0 : _c.probeSetComponent) {
                psc = this.props.formState.price.kit.probeSetComponent;
            }
        }
        else {
            psc = undefined;
        }
        if (this.props.formState.price) {
            if ((_d = this.props.formState.price.kit) === null || _d === void 0 ? void 0 : _d.chromogenComponent) {
                chromogenComponent = this.props.formState.price.kit.chromogenComponent;
            }
        }
        else {
            chromogenComponent = undefined;
        }
        var lockScalesAndToggles = this.props.formState.config !== Other;
        return React.createElement("div", { className: 'kit-form' },
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: '/' }),
            React.createElement("div", null),
            React.createElement("div", { style: { marginTop: '1.5rem' }, className: 'cish-admin-kit-component' },
                React.createElement(Grid, { columns: 4 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, null, "PROTOCOL"),
                            React.createElement(Select, { options: this.props.catalog.cishProtocols.map(function (p) {
                                    return {
                                        text: p.label,
                                        value: p.id
                                    };
                                }), onChange: this.onProtocolChange, value: this.props.formState.protocolType.id })),
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, null, "Configuration"),
                            React.createElement(Select, { options: this.props.kitConfigurations.map(function (bc) {
                                    return {
                                        text: bc,
                                        value: bc
                                    };
                                }), onChange: this.onConfigurationChange, value: this.props.formState.config })),
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, null, "ALL SCALES"),
                            React.createElement(Select, { disabled: this.props.formState.config === StarterKitProbe, options: uniqueBy(this.effectiveScales(), function (s) { return s; }).map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), onChange: this.onScaleChange, value: this.props.formState.scale, search: true }))),
                    this.props.formState.config === Other && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errorPath: '/reasonForOther', required: true, labelContent: React.createElement(Header, null, "Reason For Other"), errors: this.props.formState.errors },
                                React.createElement(Select, { options: this.otherReasons(), onChange: this.onReasonForOtherChange, value: this.props.formState.reasonForOther }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.formState.errors, errorPath: '/reasonForOtherExplanation', labelContent: React.createElement(Header, null, "Additional Details") },
                                React.createElement(Input, { onChange: this.onReasonForOtherExplanationChange, value: this.props.formState.reasonForOtherExplanation })))))),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.miscComponentEnabled, label: 'MISCELLANEOUS COMPONENT', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.ampEnabled, this.props.formState.chromogenEnabled, this.props.formState.buffersEnabled], onChange: this.onMiscComponentEnableChange, cish: true },
                React.createElement(MiscellaneousComponentForm, { miscComponentState: this.props.formState.miscComponentState, errors: this.props.formState.errors, onMiscComponentChange: this.onMiscComponentStateChange, priceLoading: this.props.formState.priceLoading, onUserSelection: this.onUserSelection, enableCustomPrice: this.props.enableCustomPrice, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.miscComponentPriceCents : undefined })),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.probeSetEnabled, otherComponentStates: [this.props.formState.ampEnabled, this.props.formState.chromogenEnabled, this.props.formState.buffersEnabled, this.props.formState.miscComponentEnabled], onChange: this.onProbeSetEnableChange, label: 'PROBE', cish: true },
                React.createElement(ProbeSetForm, { protocolType: this.props.formState.protocolType, lockScales: lockScalesAndToggles, catalog: this.props.catalog, errors: this.props.formState.errors, enableCustomPrice: this.props.enableCustomPrice, onProbeSetChange: this.onProbeSetStateChange, onUserSelection: this.onUserSelection, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.probeSetPriceCents : undefined, priceLoading: this.props.formState.priceLoading, probeSetState: this.props.formState.probeSetState, psc: psc })),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.ampEnabled, label: 'AMPLIFIER', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.chromogenEnabled, this.props.formState.buffersEnabled, this.props.formState.miscComponentEnabled], onChange: this.onAmplifierEnableChange, cish: true },
                React.createElement(AmplifierForm, { protocolType: this.props.formState.protocolType, lockScales: lockScalesAndToggles, ampState: this.props.formState.ampState, catalog: this.props.catalog.cishAmplifier, errors: this.props.formState.errors, hcrAmplifierDisabled: this.props.formState.probeSetEnabled, enableCustomPrice: this.props.enableCustomPrice, onAmpStateChange: this.onAmpStateChange, onChromogenStateChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.amplifierPriceCents : undefined, priceLoading: this.props.formState.priceLoading, ampComponent: amplifierComponent })),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.chromogenEnabled, label: 'CHROMOGEN', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.ampEnabled, this.props.formState.buffersEnabled, this.props.formState.miscComponentEnabled], onChange: this.onChromogenEnableChange, cish: true },
                React.createElement(ChromogenForm, { protocolType: this.props.formState.protocolType, lockScales: lockScalesAndToggles, ampState: this.props.formState.ampState, chromogenState: this.props.formState.chromogenState, nonOtherKit: this.props.formState.config === ProbeDetect || this.props.formState.config === DetectOnly || this.props.formState.config === ExtrasOnly, allScales: this.props.formState.scale, catalog: this.props.catalog.cishChromogens, errors: this.props.formState.errors, enableCustomPrice: this.props.enableCustomPrice, onChromogenChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.chromogenPriceCents : undefined, priceLoading: this.props.formState.priceLoading, chromogenComponent: chromogenComponent })),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.buffersEnabled, label: 'BUFFERS', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.ampEnabled, this.props.formState.chromogenEnabled, this.props.formState.miscComponentEnabled], onChange: this.onBuffersEnableChange, cish: true },
                React.createElement(BufferForm, { protocolType: this.props.formState.protocolType, lockScales: lockScalesAndToggles, bufferState: this.props.formState.bufferState, catalog: this.props.catalog.cishBuffer, enableCustomPrice: this.props.enableCustomPrice, errors: this.props.formState.errors, onBufferChange: this.onBufferStateChange, onUserSelection: this.onUserSelection, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.buffersPriceCents : undefined, priceLoading: this.props.formState.priceLoading, buffComponent: buffComponent })),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { htmlFor: 'comment' }, "Comment"),
                            React.createElement(Form.TextArea, { value: this.props.formState.comment, onChange: this.onCommentChange }))),
                    priceColumn(React.createElement("div", { style: { 'paddingRight': '.5rem' } },
                        React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.subtotalCents : undefined })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 }, this.props.formState.price && discountMessage(this.props.formState.price.discountCents, this.props.formState.price.listPriceCents)))));
    };
    ;
    AdminEditKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    AdminEditKitForm.serializeRnaCishKit = function (formState) {
        var serializer = new RnaCishAdminKitSerializer(formState.protocolType, formState.config);
        if (formState.probeSetEnabled) {
            serializer.setProbeSetState(formState.probeSetState);
        }
        if (formState.ampEnabled) {
            serializer.setAmplifier(formState.ampState);
        }
        if (formState.buffersEnabled) {
            serializer.setBuffers(formState.bufferState);
        }
        if (formState.miscComponentEnabled) {
            serializer.setMiscComponent(formState.miscComponentState);
        }
        if (formState.chromogenEnabled) {
            serializer.setChromogenComponent(formState.chromogenState);
        }
        var reasonForOther;
        if (formState.reasonForOther !== "") {
            reasonForOther = formState.reasonForOther + " (" + formState.reasonForOtherExplanation + ")";
        }
        else {
            reasonForOther = "";
        }
        return serializer.serializeKit(formState.comment, reasonForOther);
    };
    return AdminEditKitForm;
}(React.PureComponent));
export default AdminEditKitForm;
export var defaultRnaCishCatalogProbeSetState = function (catalog) { return ({
    organism: RnaCishEditableOrganism.default(),
    target: RnaCishEditableTarget.default(20),
    hcrAmplifier: catalog.cishAmplifier.defaultHcrAmplifier,
    scale: catalog.probeSet.catalog.cishDefaultScale,
    probeHybridizationAScale: catalog.probeSet.catalog.cishDefaultScale,
    probeHybridizationBScale: catalog.probeSet.catalog.cishDefaultScale,
    targets: [],
    searchQuery: '',
    searchLoading: false
}); };
export var defaultRnaCishAmpState = function (catalog) { return ({
    enzyme: catalog.enzymes.find(function (e) {
        return e.amplifier === catalog.defaultHcrAmplifier &&
            e.hapten === catalog.defaultHapten &&
            e.antiHapten1 === catalog.defaultAntiHapten1 &&
            e.tyramideHapten === catalog.defaultTyramideHapten &&
            e.antiHapten2Ap === catalog.defaultAntiHapten2Ap &&
            e.antiHapten2Hrp === catalog.defaultAntiHapten2Hrp;
    }),
    hcrAmplifier: catalog.defaultHcrAmplifier,
    hapten: catalog.defaultHapten,
    antiHapten1: catalog.defaultAntiHapten1,
    tyramideHapten: catalog.defaultTyramideHapten,
    antiHapten2Ap: catalog.defaultAntiHapten2Ap,
    antiHapten2Hrp: catalog.defaultAntiHapten2Hrp,
    amplifierScale: catalog.proDefaultAmplifierScale,
    antiHapten1Scale: catalog.proDefaultAmplifierScale,
    tyramideHaptenScale: catalog.proDefaultAmplifierScale,
    antiHapten2ApScale: catalog.proDefaultAmplifierScale,
    antiHapten2HrpScale: catalog.proDefaultAmplifierScale,
    prefilled: false
}); };
export var defaultRnaCishBufferState = function (catalog) { return ({
    sampleType: catalog.cishBuffer.defaultSampleType,
    amplificationBufferScale: catalog.cishBuffer.proDefaultBufferScale,
    blockingSolutionScale: catalog.cishBuffer.proDefaultBufferScale,
    endogenousEnzymeScale: catalog.cishBuffer.proDefaultBufferScale,
    preHybridizationScale: 0,
    hrpQuencherScale: catalog.cishBuffer.proDefaultBufferScale,
    bluingAgentScale: catalog.cishBuffer.proDefaultBufferScale,
    antigenRetrievalScale: catalog.cishBuffer.proDefaultBufferScale,
    dewaxScale: catalog.cishBuffer.proDefaultBufferScale,
}); };
export var defaultRnaCishChromogenState = function () { return ({
    chromogen: { id: 'NONE', label: 'NONE', protocolCompatibility: [], enzymeCompatibility: '', bufferCompatibility: { id: 'NONE', label: 'NONE' } },
    chromogenBuffer: { id: 'NONE', label: 'NONE' },
    chromogenScaleSlides: 0,
    chromogenBufferScaleSlides: 0,
    hematoxylinScaleSlides: 0
}); };
export var defaultAdminRnaCishFormState = function (catalog) {
    return {
        protocolType: catalog.cishProtocols[0],
        config: adminConfigurations[0],
        ampEnabled: true,
        buffersEnabled: true,
        chromogenEnabled: true,
        comment: '',
        errors: [],
        price: undefined,
        priceLoading: false,
        probeSetEnabled: true,
        reasonForOther: "",
        reasonForOtherExplanation: "",
        ampState: defaultRnaCishAmpState(catalog.cishAmplifier),
        bufferState: defaultRnaCishBufferState(catalog),
        probeSetState: defaultRnaCishCatalogProbeSetState(catalog),
        miscComponentState: defaultMiscComponentFormState(),
        chromogenState: defaultRnaCishChromogenState(),
        miscComponentEnabled: false,
        scale: catalog.probeSet.catalog.cishDefaultScale
    };
};
export var defaultMiscComponentFormState = function () {
    return {
        description: '',
        scaleInMl: 0,
        scaleInMlText: "0",
        scaleInSlides: 0,
        customPrice: {
            listPriceCents: 0,
            effectivePriceCents: 0
        }
    };
};
var BufferStateWrangler = /** @class */ (function () {
    function BufferStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ bufferState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.bufferState; };
    }
    return BufferStateWrangler;
}());
var MiscComponentStateWrangler = /** @class */ (function () {
    function MiscComponentStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ miscComponentState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.miscComponentState; };
    }
    return MiscComponentStateWrangler;
}());
var ChromogenStateWrangler = /** @class */ (function () {
    function ChromogenStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ chromogenState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.chromogenState; };
    }
    return ChromogenStateWrangler;
}());
var bufStateWrangler = new BufferStateWrangler();
var miscComponentStateWrangler = new MiscComponentStateWrangler();
var chromogenStateWrangler = new ChromogenStateWrangler();
//# sourceMappingURL=AdminEditKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/AdminEditKitForm.js
// module id = 82
// module chunks = 0